import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The personal integration surface has moved twice: out of Account Settings into a
 * top-level `/dashboard/integrations` area (2026-08-04 meeting), and from there into
 * the personal realm of settings as `/settings/integrations`, beside the other things
 * a user manages for themselves and apart from the organization's Spaces &
 * Integrations page.
 *
 * The route stays as a redirect rather than being deleted: it shipped, so it is in
 * bookmarks and in links we have already written, and a 404 is a worse answer than the
 * page they were looking for.
 */
export const Route = createFileRoute("/_authenticated/settings/connections")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/integrations" });
	},
});
